import { ChangeEvent, useEffect } from 'react'
import { Badge, HStack, Stack, Textarea } from '@chakra-ui/react'

import CustomFormFieldErrorMessage from 'components/tools/CustomForm/commonComponents/CustomFormFieldErrorMessage'
import { CustomFormViewerQuestionProps } from 'components/tools/CustomForm/types/CustomFormViewerQuestionProps'
import validateLongTextOnCustomForm from 'components/tools/CustomForm/components/Viewer/utils/validateLongTextOnCustomForm'
import { useCustomFormViewer } from 'components/tools/CustomForm/components/Viewer/contexts/CustomFormViewerManager/Provider'
import useCustomFormGetDefaultValue from '../../hooks/useCustomFormGetDefaultValue'

export default function CustomFormLongTextQuestion({
  question,
  questionKey,
  disabled,
  formMethods,
}: CustomFormViewerQuestionProps) {
  const { removeErrorFromQuestion, setErrorOnQuestion, thisQuestionHasError } = useCustomFormViewer()

  const { defaultValue } = useCustomFormGetDefaultValue({ question, questionKey, disabled })

  const questionWithError = thisQuestionHasError(question.slug)?.question

  function handleValidateLongTextQuestion(text: string) {
    const errorMessage = validateLongTextOnCustomForm({ text, question })
    if (errorMessage === '') {
      removeErrorFromQuestion(question.slug)
    } else {
      setErrorOnQuestion(question, errorMessage)
    }
  }

  function handleOnBlur(event: ChangeEvent<HTMLInputElement>) {
    const inputValue = event.target.value
    handleValidateLongTextQuestion(inputValue)
  }

  useEffect(() => {
    if (defaultValue) {
      handleValidateLongTextQuestion(defaultValue)
    }
    if (formMethods?.setValue) {
      formMethods.setValue(questionKey, defaultValue)
    }
  }, [defaultValue])

  return (
    <Stack>
      <Textarea
        id={question.slug}
        isDisabled={disabled}
        placeholder={question?.placeholder}
        value={formMethods?.watch ? formMethods.watch(questionKey) : defaultValue}
        {...(formMethods?.register && formMethods.register(questionKey, { onBlur: handleOnBlur }))}
      />

      <CustomFormFieldErrorMessage message={questionWithError?.error_message} />

      {question.validation && (
        <HStack>
          {question.validation.max && <Badge textTransform="none">Caractéres máximo ({question.validation.max})</Badge>}
        </HStack>
      )}
    </Stack>
  )
}
